import { Icon } from 'leaflet'
export const iconLocation = new Icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/5632/5632722.png',
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [35, 35],
  className: 'leaflet-venue-icon'
})
export const iconMarkerGreen = new Icon({
  iconUrl: 'music-store.png',
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [50, 50],
  className: 'leaflet-venue-icon'
})

export const iconMarkerBlue = new Icon({
  iconUrl: 'point.png',
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [40, 40],
  className: 'leaflet-venue-icon'
})

export const iconMarkerMuseo = new Icon({
  iconUrl: 'markers/3.png',
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [45, 90],
  className: 'leaflet-venue-icon'
})

export const iconMarkerCruces = new Icon({
  iconUrl: 'markers/3.png',
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [45, 90],
  className: 'leaflet-venue-icon'
})
export const iconMarkerIndepende = new Icon({
  iconUrl: 'markers/7.png',
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [45, 90],
  className: 'leaflet-venue-icon'
})
export const iconMarkerArqueologia = new Icon({
  iconUrl: 'markers/6.png',
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [45, 90],
  className: 'leaflet-venue-icon'
})
export const iconMarkerCapilla = new Icon({
  iconUrl: 'markers/2.png',
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [45, 90],
  className: 'leaflet-venue-icon'
})
export const iconMarkerArbelaez = new Icon({
  iconUrl: 'markers/4.png',
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [45, 90],
  className: 'leaflet-venue-icon'
})
